import Spaces from '@ably/spaces';
import { Realtime, RealtimeClient } from 'ably';

import { publicConfig } from '@public-config';

import { User } from 'models';

const RealtimeService = {
    initializedAsClientId: null as string | null,

    clients: null as { ably: RealtimeClient; spaces: Spaces } | null,

    init: (user: User) => {
        if (RealtimeService.clients && RealtimeService.initializedAsClientId === user.id) {
            return RealtimeService.clients;
        }

        const ably = new Realtime({
            key: publicConfig.ablyPublicKey,
            clientId: user.id,
            echoMessages: false,
            logLevel: 1,
        });

        const spaces = new Spaces(ably);

        RealtimeService.clients = { ably, spaces };
        RealtimeService.initializedAsClientId = user.id;

        return RealtimeService.clients;
    },
};

export { RealtimeService };
